export const PLAYER_UPDATE_DETAILS_ERROR_CODES = {
  EMAIL_ALREADY_REGISTERED_ERROR_CODE: 7,
};
